export default "__VITE_ASSET__b4bc79dd__"